(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('QuilistController', QuilistController);

    QuilistController.$inject = ['$state', '$timeout', 'Company', 'Collectivity', 'AlertService', 'paginationConstants'];

    function QuilistController($state, $timeout, Company, Collectivity, AlertService, paginationConstants) {
        var vm = this;

        vm.companies = [];
        vm.collectivities = [];
        vm.companiesActive = false;
        vm.collectivitiesActive = false;
        vm.searchTextCompanies = '';
        vm.searchTextCollectivities = '';
        vm.pageCompanies = 1;
        vm.pageCollectivities = 1;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.searchCompanies = searchCompanies;
        vm.searchCollectivities = searchCollectivities;
        vm.loadMoreCompanies = loadMoreCompanies;
        vm.loadMoreCollectivities = loadMoreCollectivities;
        vm.choose = choose;
        vm.firstLetter = firstLetter;

        init();

        // Prevent inbox pop-up from window scrolling
        $timeout(function () {
            angular.element('#company-container').bind('DOMMouseScroll mousewheel', preventScrollPropagation);
            angular.element('#collectivity-container').bind('DOMMouseScroll mousewheel', preventScrollPropagation);
        });

        function init() {
            Company.query({
                page: 0,
                size: vm.itemsPerPage
            }, onCompaniesSuccess, onFetchError);

            Collectivity.query({
                page: 0,
                size: vm.itemsPerPage
            }, onCollectivitiesSuccess, onFetchError);

            function onCompaniesSuccess(data, headers) {
                data = data.filter(function(val) {
                    return val.nameNormalized !== 'independant';
                });
                vm.companies = data;
                vm.hasNextPageCompanies = headers('X-Has-Next-Page') === "true";
            }
            function onCollectivitiesSuccess(data, headers) {
                vm.collectivities = data;
                vm.hasNextPageCollectivities = headers('X-Has-Next-Page') === "true";
            }
        }

        function searchCompanies() {
            vm.pageCompanies = 1;
            if (vm.searchTextCompanies) {
                Company.search({
                    query: vm.searchTextCompanies,
                    page: vm.pageCompanies - 1,
                    size: vm.itemsPerPage
                }, onCompaniesSuccess, onFetchError);
            } else {
                Company.query({
                    page: vm.pageCompanies - 1,
                    size: vm.itemsPerPage
                }, onCompaniesSuccess, onFetchError);
            }

            function onCompaniesSuccess(data, headers) {
                data = data.filter(function(val) {
                    return val.nameNormalized !== 'independant';
                });
                vm.companies = data;
                vm.hasNextPageCompanies = headers('X-Has-Next-Page') === "true";
            }
        }

        function searchCollectivities() {
            vm.pageCollectivities = 1;
            if (vm.searchTextCollectivities) {
                Collectivity.search({
                    query: vm.searchTextCollectivities,
                    page: vm.pageCollectivities - 1,
                    size: vm.itemsPerPage
                }, onCollectivitiesSuccess, onFetchError);
            } else {
                Collectivity.query({
                    page: vm.pageCollectivities - 1,
                    size: vm.itemsPerPage
                }, onCollectivitiesSuccess, onFetchError);
            }

            function onCollectivitiesSuccess(data, headers) {
                vm.collectivities = data;
                vm.hasNextPageCollectivities = headers('X-Has-Next-Page') === "true";
            }
        }

        function loadMoreCompanies() {
            vm.pageCompanies += 1;

            if (vm.searchTextCompanies) {
                Company.search({
                    query: vm.searchTextCompanies,
                    page: vm.pageCompanies - 1,
                    size: vm.itemsPerPage
                }, onCompaniesSuccess, onFetchError);
            } else {
                Company.query({
                    page: vm.pageCompanies - 1,
                    size: vm.itemsPerPage
                }, onCompaniesSuccess, onFetchError);
            }

            function onCompaniesSuccess(data, headers) {
                data = data.filter(function(val) {
                    return val.nameNormalized !== 'independant';
                });
                vm.companies = vm.companies.concat(data);
                vm.hasNextPageCompanies = headers('X-Has-Next-Page') === "true";
            }
        }

        function loadMoreCollectivities() {
            vm.pageCollectivities += 1;

            if (vm.searchTextCollectivities) {
                Collectivity.search({
                    query: vm.searchTextCollectivities,
                    page: vm.pageCollectivities - 1,
                    size: vm.itemsPerPage
                }, onCollectivitiesSuccess, onFetchError);
            } else {
                Collectivity.query({
                    page: vm.pageCollectivities - 1,
                    size: vm.itemsPerPage
                }, onCollectivitiesSuccess, onFetchError);
            }

            function onCollectivitiesSuccess(data, headers) {
                vm.collectivities = vm.collectivities.concat(data);
                vm.hasNextPageCollectivities = headers('X-Has-Next-Page') === "true";
            }
        }

        function choose(sectionName) {
            vm.companiesActive = (sectionName === 'companies');
            vm.collectivitiesActive = (sectionName === 'collectivities');
        }

        function firstLetter(name) {
            return name && name.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace('æ', 'ae').charAt(0).toUpperCase();
        }

        function onFetchError(error) {
            AlertService.error(error.data.message);
        }

        function preventScrollPropagation(ev) {
            var $this = $(this),
                scrollTop = this.scrollTop,
                scrollHeight = this.scrollHeight,
                height = $this.innerHeight(),
                delta = (ev.type == 'DOMMouseScroll' ?
                ev.originalEvent.detail * -40 :
                    ev.originalEvent.wheelDelta),
                up = delta > 0;

            var prevent = function() {
                ev.stopPropagation();
                ev.preventDefault();
                ev.returnValue = false;
                return false;
            };

            if (!up && -delta > scrollHeight - height - scrollTop) {
                // Scrolling down, but this will take us past the bottom.
                $this.scrollTop(scrollHeight);
                return prevent();
            } else if (up && delta > scrollTop) {
                // Scrolling up, but this will take us past the top.
                $this.scrollTop(0);
                return prevent();
            }
        }
    }
})();
